import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrMF: CultureInfo = {
  name: 'fr-MF',
  displayName: 'français (Saint-Martin)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-MF',
  parent: CultureInfoFr
};
